import React from "react";
import { Link, useNavigate } from "react-router-dom"
import { Button } from '@material-ui/core'

function AdminNav() {

    const currentUser = localStorage.getItem("firstName") + " " + localStorage.getItem("secondName") || "user"
    const navigate = useNavigate();

    const logout = () => {
        localStorage.clear();
        navigate('/login');
    }

    return (
        <div className="navigationContainer">
            <nav>
                <Link to='/adminHomepage' className="navLink">
                    <p>Home</p>
                </Link>
                <Link to='/adminDates' className="navLink">
                    <p>Dates</p>
                </Link>
                <Link to='/adminManageStudents' className="navLink">
                    <p>Student Projects</p>
                </Link>
                <Link to='/adminManageLecturers' className="navLink">
                    <p>Lecturer Projects</p>
                </Link>
                <Link to='/adminManageUsers' className="navLink">
                    <p>Users</p>
                </Link>
                {currentUser ? (
                    <div className="navOptions">
                        <p>{currentUser}</p>
                        <Button onClick={logout}><p className="buttontext">Logout</p></Button>
                    </div>
                ) : (
                    <Link to="/login">
                    <button type="button">
                        Sign in
                    </button>
                </Link>
                )}
            </nav>
        </div>
    ) 
}

export default AdminNav;